import { createFileRoute, useMatch } from '@tanstack/react-router'
import { NAVIGATION_ICONS } from './-components/shared/navigation-config'
import { useLingui } from '@lingui/react/macro'
import { ReportComponent } from '@/routes/_app/-components/report/report'
import { Logo } from './-components/shared/logo'
import { useAppStore } from '@/lib/app-store'
import { PageLayout, ScrollableContent, ScrollableArea } from './-components/shared/layout'
import { BreadcrumbTrail } from './-components/title-section'
import { ReportPaneSkeleton } from './-components/app-layout-skeleton'
import { useReport } from '@/hooks/use-report'
import { useIsLivePane } from '@/components/custom/route-transition'

export const Route = createFileRoute('/_app/report')({
  component: RouteComponent,
  pendingComponent: ReportPanePending,
  // Painted on the click frame; safe only because the report KEY is not this match's: it lives on the pathless
  // `_report` layout below, so an ámbito or Detailed/Summary switch re-keys a match that paints nothing
  // (report-engine.e2e.test pins the keep-previous).
})

// Not animated in: the report lands in the skeleton's box, and a skeleton still sliding would make it jump there.
function ReportPanePending() {
  return <ReportPaneSkeleton />
}

function RouteComponent() {
  const isLivePane = useIsLivePane()
  const { t } = useLingui()
  const extension = useAppStore((state) => state.store.extension)
  const callback = useAppStore((state) => state.store.callback)
  const { context } = useMatch({ from: '/_app/report/_report' })
  const { report, isFetching } = useReport(context.reportQueryOptions)
  // Access (a company-view employee has no personal report → /jobs) is enforced centrally by the `_app`
  // layout guard (see route-access), before this route's gated `getReport` query ever mounts.

  return (
    <>
      <div id={isLivePane ? 'report' : undefined} className="@container flex h-full flex-col">
        {extension && <Logo openInNewTab />}
        <PageLayout
          icon={NAVIGATION_ICONS.report}
          title={t`My report`}
          breadcrumbsSlot={<BreadcrumbTrail items={[t`My report`]} />}
        >
          <ScrollableContent>
            <ScrollableArea>
              <ReportComponent report={report} isFetching={isFetching} callback={callback} />
            </ScrollableArea>
          </ScrollableContent>
        </PageLayout>
      </div>
    </>
  )
}
